import { render, staticRenderFns } from "./ApiClients.vue?vue&type=template&id=7fae42cb&scoped=true"
import script from "./ApiClients.vue?vue&type=script&lang=js"
export * from "./ApiClients.vue?vue&type=script&lang=js"
import style0 from "./ApiClients.vue?vue&type=style&index=0&id=7fae42cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fae42cb",
  null
  
)

export default component.exports